<template>
  <div class="l-acount-tab">
    <ul>
      <li @click="goCorporateEdit()" :class="{ 'is-current' : this.$route.name === 'corporate-new' || this.$route.name === 'corporate-edit' || this.$route.name === 'account-edit' }"><a>基本情報</a></li>
      <li v-show="!isNew" @click="goUserEdit()" :class="{ 'is-current' : this.$route.name === 'user-list' || this.$route.name === 'user-new' || this.$route.name === 'user-edit' || this.$route.name === 'account-user-new' || this.$route.name === 'account-user-edit' }"><a>ユーザー</a></li>
      <li v-show="!isNew" @click="goWorkplace()" :class="{ 'is-current' : this.$route.name === 'workplace-list' || this.$route.name === 'account-workplace-list' }"><a>事業場</a></li>
    </ul>
  </div>
</template>

<script>
export default {
  props: {
    isNew: {
      type: Boolean,
      default: true,
    }
  },
  computed: {
    corpId() {
      return this.$store.getters['diag/getCorpId'];
    },
    userId() {
      return this.$store.getters['user/getUserId'];
    },
  },
  methods: {
    goCorporateEdit() {
      const params = {};
      if (this.$route.meta.isAccountEdit) {
        if (this.isNew) {
          this.$router.push({ name: 'account-edit', params: params });
        } else {
          this.$router.push({ name: 'account-edit', query: { corpId: this.corpId} });
        }
      } else {
        if (this.isNew) {
          this.$router.push({ name: 'corporate-edit', params: params });
        } else {
          this.$router.push({ name: 'corporate-edit', query: { corpId: this.corpId} });
        }

      }
    },
    goWorkplace() {
      if (this.$route.meta.isAccountEdit) {
        this.$router.push({ name: 'account-workplace-list', query: { corpId: this.corpId } });
      } else {
        this.$router.push({ name: 'workplace-list', query: { corpId: this.corpId } });
      }
    },
    goUserEdit() {
      const params = {};
      if (this.$route.meta.isAccountEdit) {
        if (this.userId) {
          this.$router.push({ name: 'account-user-edit', query: { userId: this.userId} });
        } else {
          this.$router.push({ name: 'account-user-edit', params: params });
        }
      } else {
        if (this.userId) {
          this.$router.push({ name: 'user-edit', query: { userId: this.userId} });
        } else {
          this.$router.push({ name: 'user-edit', params: params });
        }
      }
    }
  }
}
</script>

<style scoped>
span {
  margin: 10px;
}
</style>
